// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__WnzYf","content":"GlobalSearch_content__3rHab"};